export var UnrealisedAssetFXGainOrLossType;
(function (UnrealisedAssetFXGainOrLossType) {
    UnrealisedAssetFXGainOrLossType["UnrealisedAssetFXGain"] = "UnrealisedAssetFXGain";
    UnrealisedAssetFXGainOrLossType["UnrealisedAssetFXLoss"] = "UnrealisedAssetFXLoss";
    UnrealisedAssetFXGainOrLossType["UnrealisedAssetFXUnwindGain"] = "UnrealisedAssetFXUnwindGain";
    UnrealisedAssetFXGainOrLossType["UnrealisedAssetFXUnwindLoss"] = "UnrealisedAssetFXUnwindLoss";
})(UnrealisedAssetFXGainOrLossType || (UnrealisedAssetFXGainOrLossType = {}));
//# sourceMappingURL=index.js.map